import IconItem from '@ifca-root/react-component/src/components/Avatar/IconItem'
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from '@material-ui/core'
import { KeyboardArrowRight } from '@material-ui/icons'
import WriteOffDisposal from 'assets/icons/FixedAssets/Write-Off-Disposal.svg'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import {
  useGetCompanySummaryQuery,
  useGetDocNumTitleQuery,
} from 'generated/graphql'
import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router'

export const NestedNumberingStructureSubmenu = (props: any) => {
  let history = useHistory()
  const { mode: pageMode, submode } = props
  const { CompanyID }: any = useParams()
  const [errMessage, setErrMessage] = useState(null)
  const [errDialog, setErrDialog] = useState(false)

  const {
    loading,
    data: { getCompany: curCompany } = { getCompany: [] },
  } = useGetCompanySummaryQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  //GET DOC HEADER
  const {
    loading: DocNumHeaderLoading,
    data: { getDocumentNumberHeader } = { getDocumentNumberHeader: [] },
  } = useGetDocNumTitleQuery({
    fetchPolicy: 'network-only',
    variables: { CompanyID: CompanyID },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  // FIXED ASSET - ASSET CHANGE SUBMENU

  const increaseOriginalValue = {
    path: `/fixed-assets/${CompanyID}/company-setting/numbering-structure/asset-change/increase-value`,
    icon: WriteOffDisposal,
    title: `Increase In Original Value`,
    label1:
      getDocumentNumberHeader.find(
        x => x?.RefTable === 'fa_asset_increase_original_value'
      )?.SampleOutput || '-',
    data1: ``,
    data2: ``,
    data3: ``,
  }

  const decreaseOriginalValue = {
    path: `/fixed-assets/${CompanyID}/company-setting/numbering-structure/asset-change/decrease-value`,
    icon: WriteOffDisposal,
    title: `Decrease In Original Value`,
    label1:
      getDocumentNumberHeader.find(
        x => x?.RefTable === 'fa_asset_decrease_original_value'
      )?.SampleOutput || '-',
    data1: ``,
    data2: ``,
    data3: ``,
  }

  const usefulLife = {
    path: `/fixed-assets/${CompanyID}/company-setting/numbering-structure/asset-change/useful-life`,
    icon: WriteOffDisposal,
    title: `Useful Life`,
    label1:
      getDocumentNumberHeader.find(x => x?.RefTable === 'fa_useful_life')
        ?.SampleOutput || '-',
    data1: ``,
    data2: ``,
    data3: ``,
  }

  const depreciationMethod = {
    path: `/fixed-assets/${CompanyID}/company-setting/numbering-structure/asset-change/depreciation-method`,
    icon: WriteOffDisposal,
    title: `Depreciation Method`,
    label1:
      getDocumentNumberHeader.find(
        x => x?.RefTable === 'fa_asset_depreciation_method'
      )?.SampleOutput || '-',
    data1: ``,
    data2: ``,
    data3: ``,
  }

  const totalDepreciation = {
    path: `/fixed-assets/${CompanyID}/company-setting/numbering-structure/asset-change/total-depreciation`,
    icon: WriteOffDisposal,
    title: `Total Depreciation`,
    label1:
      getDocumentNumberHeader.find(x => x?.RefTable === 'fa_total_depreciation')
        ?.SampleOutput || '-',
    data1: ``,
    data2: ``,
    data3: ``,
  }

  const residualValue = {
    path: `/fixed-assets/${CompanyID}/company-setting/numbering-structure/asset-change/residual-value`,
    icon: WriteOffDisposal,
    title: `Residual Value (%)`,
    label1:
      getDocumentNumberHeader.find(x => x?.RefTable === 'fa_residual_value')
        ?.SampleOutput || '-',
    data1: ``,
    data2: ``,
    data3: ``,
  }

  const provisionForImpairment = {
    path: `/fixed-assets/${CompanyID}/company-setting/numbering-structure/asset-change/provision-impairment`,
    icon: WriteOffDisposal,
    title: `Provision for Impairment`,
    label1:
      getDocumentNumberHeader.find(
        x => x?.RefTable === 'fa_provision_impairment'
      )?.SampleOutput || '-',
    data1: ``,
    data2: ``,
    data3: ``,
  }

  const provisionForImpairmentReversal = {
    path: `/fixed-assets/${CompanyID}/company-setting/numbering-structure/asset-change/provision-impairment-reversal`,
    icon: WriteOffDisposal,
    title: `Provision for Impairment Reversal`,
    label1:
      getDocumentNumberHeader.find(
        x => x?.RefTable === 'fa_provision_impairment_reversal'
      )?.SampleOutput || '-',
    data1: ``,
    data2: ``,
    data3: ``,
  }

  const assetTransferByDepartment = {
    path: `/fixed-assets/${CompanyID}/company-setting/numbering-structure/asset-change/asset-transfer-department`,
    icon: WriteOffDisposal,
    title: `Asset Transfer By Department`,
    label1:
      getDocumentNumberHeader.find(
        x => x?.RefTable === 'fa_asset_transfer_department'
      )?.SampleOutput || '-',
    data1: ``,
    data2: ``,
    data3: ``,
  }

  const assetChangeCategory = {
    path: `/fixed-assets/${CompanyID}/company-setting/numbering-structure/asset-change/change-asset-category`,
    icon: WriteOffDisposal,
    title: `Change Asset Category`,
    label1:
      getDocumentNumberHeader.find(
        x => x?.RefTable === 'fa_change_asset_category'
      )?.SampleOutput || '-',
    data1: ``,
    data2: ``,
    data3: ``,
  }
  // const assetChangeApportionment = {
  //   path: `/fixed-assets/${CompanyID}/company-setting/numbering-structure/asset-change/change-apportionment`,
  //   icon: WriteOffDisposal,
  //   title: `Change Apportionment`,
  //   label1:
  //     getDocumentNumberHeader.find(
  //       x => x?.RefTable === 'fa_change_apportionment'
  //     )?.SampleOutput || '-',
  //   data1: ``,
  //   data2: ``,
  //   data3: ``,
  // }
  const assetTransferByLocation = {
    path: `/fixed-assets/${CompanyID}/company-setting/numbering-structure/asset-change/asset-transfer-location`,
    icon: WriteOffDisposal,
    title: `Asset Transfer By Location`,
    label1:
      getDocumentNumberHeader.find(
        x => x?.RefTable === 'fa_asset_transfer_location'
      )?.SampleOutput || '-',
    data1: ``,
    data2: ``,
    data3: ``,
  }

  let submenuList = []
  let title = ''
  let smTitle = ''
  if (pageMode === 'fixed-assets' && submode === 'asset-change') {
    title = 'Asset Change'
    smTitle = 'Fixed Assets'
    submenuList = [
      increaseOriginalValue,
      decreaseOriginalValue,
      usefulLife,
      depreciationMethod,
      totalDepreciation,
      residualValue,
      provisionForImpairment,
      provisionForImpairmentReversal,
      assetTransferByDepartment,
      assetChangeCategory,
      // assetChangeApportionment,
      assetTransferByLocation,
    ]
  }

  return (
    <>
      {loading && <Loading />}
      {DocNumHeaderLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(
            `/${pageMode}/${CompanyID}/company-setting/numbering-structure`
          )
        }}
        smTitle={smTitle}
        title={curCompany[0]?.Name}
        routeSegments={[
          { name: 'Company Setting' },
          { name: 'Document Numbering' },
          { name: title, current: true },
        ]}
      />
      <DynamicSubHeader title={curCompany[0]?.Name} />
      <ContentWrapper singleDynamicInfo>
        <List className="core-list">
          {submenuList.map((el, index) => {
            return (
              <ListItem key={index}>
                <IconItem image={el?.icon} imageType="svg" badgeType="number" />
                <ListItemText
                  primary={<span className="xsTitle">{el?.title}</span>}
                  secondary={
                    <span className="desc">
                      {el?.label1 && <span className="desc">{el?.label1}</span>}
                    </span>
                  }
                />
                <ListItemSecondaryAction className="p-t-10">
                  <IconButton>
                    <KeyboardArrowRight
                      onClick={() => history.push({ pathname: el?.path })}
                    />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            )
          })}
        </List>
      </ContentWrapper>
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
